<template>
  <div :class="{ isHideNavigation: hideNavigation }">
    <p-vue-table responsiveLayout="scroll" :value="readings" dataKey="ID">
      <p-vue-column field="ReadDate" :header="__('on the date')">
        <template #body="{ data }">
          {{
            data.IsFirstReading
              ? __('Initial reading')
              : dateFormat(new Date(data.ReadDate))
          }}
        </template>
      </p-vue-column>
      <p-vue-column field="ReadCount" :header="__('Meter reading')">
      </p-vue-column>
      <p-vue-column field="ReadDate" :header="__('Total consumption')">
        <template #body="{ data }">
          {{
            data.IsFirstReading
              ? ''
              : __u_value__({
                  value: getTotalConsumption(data),
                  unit: 'number-f',
                })
          }}
        </template>
      </p-vue-column>
      <p-vue-column field="ReadDate">
        <template #body="{ data }">
          <a
            v-if="data.PathImg"
            href="#"
            @click.prevent="showBigImg(data.PathImg)"
            ><i class="pi pi-eye "></i>
          </a>
        </template>
      </p-vue-column>
      <p-vue-column field="IsFirstReading" style="padding: 12px 0;">
        <template #body="{ data }">
          <div class="p-d-flex">
            <p-vue-button
              v-if="data.IsLastReading"
              icon="pi pi-pencil"
              class="p-button-rounded p-button-success p-button-outlined"
              @click="editReading"
            />
            <p-vue-button
              v-if="data.IsLastReading"
              icon="pi pi-trash"
              class="p-button-rounded p-button-danger p-button-outlined p-mx-1"
              @click="confirmDelete($event, data.ID)"
            />
          </div>
        </template>
      </p-vue-column>
    </p-vue-table>
  </div>
  <div v-if="hideNavigation" class="p-d-flex p-jc-end">
    <p-vue-button
      :label="__('Return')"
      class="p-button-rounded p-button-success p-ml-3 p-mt-2"
      @click="back()"
    />
  </div>

  <p-img
    v-if="showImg"
    :imgPath="showImg"
    :openModal="true"
    @return="showImg = null"
    :allImages="allImages"
  />
  <i-plus-button
    @click="
      $router.push({
        name: 'ConsumptionReport',
        params: {
          meterid: meterID,
          bid: BID,
        },
      })
    "
    :text="__('Enter meter reading')"
  />
  <p-vue-confirm-popup></p-vue-confirm-popup>
</template>

<script>
import { callProc, apiParam, apiPType } from '@/services/APointAPI'
import {
  errorReceived,
  dateFormat,
  showSuccessOrFailedModal,
} from '@/services/apointUtil'
import PImg from '@/components/partials/p-img'
import { mapState } from 'vuex'
import { __ } from '@/plugins/i18n/'

export default {
  components: {
    PImg,
  },
  data() {
    return {
      meterID: this.$route.params.meterid,
      BID: this.$route.params.bid,
      readings: [],
      dateFormat,
      showImg: null,
      allImages: [],
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.$store.dispatch('doLoading', true)
      let procParams = [apiParam('MeterID', this.meterID, apiPType.Int)]
      callProc('App_GetReadingsToMeter', procParams)
        .then((result) => {
          this.$store.dispatch('doLoading', false)
          result = JSON.parse(result)
          this.readings = result.Table
          // console.log(this.readings);
        })
        .catch(() => {
          errorReceived('App_GetReadingsToMeter')
        })
    },
    showBigImg(imgPath) {
      this.showImg = imgPath
      this.allImages = []
      this.allImages.push({ imgPath: imgPath, imgSubject: '' })
    },
    back() {
      this.$router.go(-1)
    },
    getTotalConsumption(currentRow) {
      const currentReadCount = currentRow.ReadCount
      const closestPreviousObj = this.readings.find(
        (obj) => new Date(obj.ReadDate) < new Date(currentRow.ReadDate)
      )

      if (closestPreviousObj) {
        const previousReadCount = closestPreviousObj.ReadCount
        return currentReadCount - previousReadCount
      } else {
        return currentReadCount
      }
    },
    editReading() {
      this.$router.push({ name: 'EditReport' })
    },
    confirmDelete(event, id) {
      this.$confirm.require({
        target: event.currentTarget,
        message: __('Are you sure you want to delete this reading?'),
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.deleteMeter(id)
        },
        reject: () => {},
      })
    },
    deleteMeter(id) {
      this.$store.dispatch('doLoading', true)
      let procParams = [apiParam('MeterReadingId', id, apiPType.Int)]
      callProc('WorkerApp_DeleteMeterReading', procParams)
        .then((result) => {
          result = JSON.parse(result)
          if (result.procReturnValue == 0) {
            showSuccessOrFailedModal(__('The reading was deleted successfully'))
            this.getData()
          } else {
            let msg = 'An error occurred while deleting the reading'
            switch (result.procReturnValue) {
              case 2:
                msg =
                  'Payment has been made for a current meter reading, cannot be updated, in order to update the meter reading, the payment must be associated with another charge or a credit must be made'
                break
              case 3:
                msg = 'Only the last meter reading can be deleted'
                break
              default:
                msg = 'An error occurred while deleting the reading'
                break
            }
            showSuccessOrFailedModal(__(msg), false)
          }
          this.$store.dispatch('doLoading', false)
        })
        .catch((err) => {
          errorReceived('WorkerApp_DeleteMeterReading', err)
        })
    },
  },
  computed: {
    ...mapState({
      hideNavigation: (state) => state.api.hideNavigation,
    }),
  },
}
</script>

<style scoped>
.isHideNavigation {
  height: 83vh;
}
</style>
